import { createFileRoute, linkOptions } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import NotFoundResource from '@/components/router/not-found-resource'
import RouteSheet from '@/components/sheets/route-sheet'

export const Route = createFileRoute(
  '/app/data/companies/$uuid/(mainPage)/insured/insistences/$coverageUuid',
)({
  component: RouteComponent,
  errorComponent: (props) => {
    const { t } = useTranslation()

    return (
      <NotFoundResource
        {...props}
        resourceType={t('resource-not-found.not-found.coverage.resource-type')}
        backTo={t(
          'resource-not-found.not-found.coverage.back-to-coverages-list',
        )}
        backToLink={backLink}
      />
    )
  },
})

const backLink = linkOptions({
  from: Route.fullPath,
  to: '/app/data/companies/$uuid/insured/insistences',
})

function RouteComponent() {
  return <RouteSheet closeLink={backLink} />
}
